import React from "react";
import './add-clicker-id.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
// import { register } from "../../../../main/register";

class AddClickerId extends React.Component {

    state = {
        selectedSet: {},
        isListening: false,
        errorMessage: '',
        clickerType: ''
    }

    inputRefs = {}

    alphabetHash = {
        1: 'a',
        2: 'b',
        3: 'c',
        4: 'd',
        5: 'e',
        6: 'f',
        7: 'g',
        8: 'h'
    }


    constructor(props) {
        super(props)
        console.log(this.props.selectedSet)
        this.state.schoolName = this.props.schoolName
        this.state.selectedSet = this.props.selectedSet
        this.state.schoolId = this.props.selectedSchoolId
        this.state.isListening = false
    }

    componentDidMount() {
        // window.electron.remoteControl.close();
        this.handleStartListening()



        console.log(this.props.selectedSet)

        if (!this.props.selectedSet.teacherClickerId && !this.props.selectedSet.studentClickerList.length) {
            let obj = {
                rollNumber: 10000,
                deviceMacId: "",
                testedAllKeys: false,
                a: false,
                b: false,
                c: false,
                d: false,
                e: false,
                f: false,
                g: false,
                h: false
            }

            let selectedSet = this.state.selectedSet

            selectedSet.teacherClickerId = obj
            selectedSet.studentClickerList = [{
                rollNumber: 1,
                deviceMacId: "",
                voltage: '',
                testedAllKeys: false,
                a: false,
                b: false,
                c: false,
                d: false,
                e: false
            }]
            this.setState({ selectedSet })
        }
    }


    // startRegister() {
    //       window.electron.remoteControl.register(255, 255, 1).then(data => {
    //         console.log(data)
    //         this.handleStartListening()
    //     })
    // }



    handleStartListening = () => {
        const { isListening } = this.state;

        console.log(isListening)

        if (window.electron && window.electron.remoteControl) {
            if (isListening) {
                this.setState({ isListening: false });
                window.electron.remoteControl.unsubscribeEvents();
                window.electron.remoteControl.close();
            } else {
                this.setState({ isListening: true, errorMessage: '' });
                console.log('Opening remote control', window.electron.remoteControl.open());
               
                window.electron.remoteControl.open();



                // console.log(registerData)

                


                window.electron.remoteControl.subscribeEvents((data) => {
                    console.log('Received data:', data);

                    // this.startRegisteringClicker()
                    

                    // window.electron.remoteControl.register(255, 255, data.payload.value).then(dataForRegister => {
                    //     console.log("recevied in Register", dataForRegister)
                    // })

                    // this.register(255, 255, 1).then(clickerData => {
                    //     console.log(clickerData)
                    // }).catch(err => {
                    //     console.log(err)
                    // })

                    // window.electron.remoteControl.startRegister(255, 255, 1)
                    //     .then((clickerId) => {
                    //         console.log(clickerId)
                    // console.log(this.state.clickerType)
                    if (data.payload.id && this.state.clickerType === 'TEACHER_CLICKER') {
                        // window.electron.remoteControl.startRegister(255, 255, data.payload.value)
                        this.processScannedDataForTeacherClicker(data)
                    } else if(data.payload.id && this.state.clickerType === 'STUDENT_CLICKER') {
                        // window.electron.remoteControl.startRegister(255, 255, data.payload.value)
                        this.processScannedData(data)
                    }
                    // });
                });

            }
            window.electron.ipcRenderer.once('ipc-example', (arg) => {
                // eslint-disable-next-line no-console
                console.log(arg);
            });
            window.electron.ipcRenderer.send('ipc-example', ['ping']);
        }

    };




    startRegisteringClicker(value) {
        console.log('window', window.electron)
        if (window.electron && window.electron.remoteControl) {

            window.electron.remoteControl.register(255, 255, value).then(dataForRegister => {
                console.log("recevied in Register in JS", dataForRegister)
            })

        } else {
            console.log('Electron not available')
        }

    }





    isMacIdUnique = (macId) => {
        return !this.state.selectedSet.studentClickerList.some((item) => item.deviceMacId === macId);
    };


    processScannedData = (scannedData) => {
        const { id, value, voltage } = scannedData.payload; // Assume scanned data contains these fields

        let alphabetKey = this.alphabetHash[value]

        console.log(id, value, voltage)
        this.setState({ errorMessage: '' })

         if(this.isMacIdUnique(id)) { 
            console.log("register clicker", value);  
            // this.startRegisteringClicker(value);
        }
        

        if (!this.isMacIdUnique(id)) {

            console.log(id)
            // this.setState({ errorMessage: `MAC ID ${id} already exists!` });this.setState({ errorMessage: `MAC ID ${id} already exists!` });

            let alreadyExists = ''

            const updatedItems = this.state.selectedSet.studentClickerList.map((item) => {
                if (item.deviceMacId === id && !item.testedAllKeys) {
                    // Fill the first empty row or update existing row
                    item[alphabetKey] = true

                    return {
                        ...item,
                        deviceMacId: id,
                        voltage,
                        testedAllKeys: item.a && item.b && item.c && item.d && item.e
                    };
                } else if (!item.testedAllKeys) {
                    this.setState({ errorMessage: `MAC ID ${id} already exists!` }); this.setState({ errorMessage: `MAC ID ${id} already exists!` });
                }

                return item;
            });


            let selectedSet = this.state.selectedSet

            selectedSet.studentClickerList = updatedItems

            this.setState({ selectedSet }, this.checkAndAddRow);
            return;
        }

        console.log('here')

        const updatedItems = this.state.selectedSet.studentClickerList.map((item) => {
            if (item.deviceMacId === "" || item.deviceMacId === undefined || item.deviceMacId === id) {
                // Fill the first empty row or update existing row

                item[alphabetKey] = true

                return {
                    ...item,
                    deviceMacId: id,
                    voltage,
                    testedAllKeys: item.a && item.b && item.c && item.d && item.e
                };
            }
            return item;
        });

        let selectedSet = this.state.selectedSet

        selectedSet.studentClickerList = updatedItems

        console.log(selectedSet)

        this.setState({ selectedSet });
    };

    processScannedDataForTeacherClicker = (scannedData) => {
        const { id, value, voltage } = scannedData.payload; // Assume scanned data contains these fields

        let alphabetKey = this.alphabetHash[value]

        // console.log(id, value, voltage)

        let obj = this.state.selectedSet.teacherClickerId

        if (!obj.a && !obj.b && !obj.c && !obj.d && !obj.e && !obj.f && !obj.g && !obj.h) {
            // this.startRegisteringClicker(value);
        }

        obj['deviceMacId'] = id
        obj['voltage'] = voltage
        obj[alphabetKey] = true



        obj['testedAllKeys'] = obj.a && obj.b && obj.c && obj.d && obj.e

        let selectedSet = this.state.selectedSet

        selectedSet.teacherClickerId = obj

        this.setState({ selectedSet });
        return;
    };

    checkAndAddRow = () => {
        const allRowsValid = this.state.selectedSet.studentClickerList.every((item) => item.testedAllKeys);

        if (allRowsValid) {
            this.addItem();
        }
    };

    addItem = () => {
        const newRollNumber = this.state.selectedSet.studentClickerList.length
            ? this.state.selectedSet.studentClickerList[this.state.selectedSet.studentClickerList.length - 1].rollNumber + 1
            : 1;

        let selectedSet = this.state.selectedSet

        if (this.state.selectedSet.studentClickerList.length === +this.state.selectedSet.clickerCount) {
            return;
        }

        selectedSet.studentClickerList = [...selectedSet.studentClickerList, {
            rollNumber: newRollNumber,
            deviceMacId: "",
            voltage: '',
            testedAllKeys: false,
            a: false,
            b: false,
            c: false,
            d: false,
            e: false
        }]

        this.setState({ selectedSet },
            () => {
                if (this.inputRefs[newRollNumber]) {
                    this.inputRefs[newRollNumber].focus();
                }
            }
        );
    };

    handleMacIdChange(rollNumber) {
        this.removeItem(rollNumber)
    }

    removeItem = (rollNumber) => {

        let selectedSet = this.state.selectedSet

        if (this.state.clickerType === 'TEACHER_CLICKER') {
            selectedSet.teacherClickerId = {
                rollNumber: 10000,
                deviceMacId: "",
                testedAllKeys: false,
                a: false,
                b: false,
                c: false,
                d: false,
                e: false,
                f: false,
                g: false,
                h: false
            }

            this.setState(
                { selectedSet }
            );

            return
        } else {
            let studentClickerList = selectedSet.studentClickerList.filter((item) => item.rollNumber !== rollNumber)

            studentClickerList.forEach((item, index) => {
                item.rollNumber = index + 1
            })

            selectedSet.studentClickerList = studentClickerList

            this.setState(
                { selectedSet },
                this.checkAndAddRow
            );
        }
    };



    componentWillUnmount() {
        // Cleanup on component unmount
        if (window.electron && window.electron.remoteControl) {
            window.electron.remoteControl.unsubscribeEvents();
            window.electron.remoteControl.close();

        }
    }


    onClickBack() {
        this.props.delegate && this.props.delegate.hideAddClickerIdScreen && this.props.delegate.hideAddClickerIdScreen()
    }




    addClickerIdToSet() {

        let studentClickerList = this.state.selectedSet.studentClickerList.filter(item => item.deviceMacId != '')

        console.log(this.state.selectedSet)

        if (!this.state.selectedSet.teacherClickerId.testedAllKeys) {
            this.setState({ errorMessage: 'Required Teacher Clicker Id and Key Validation' })
            return
        }

        if (studentClickerList.length != +this.state.selectedSet.clickerCount) {
            this.setState({ errorMessage: 'Clicker Count in this set is not Equal to Added Clicker Count' })
            return
        }

        let allClickerKeyValidationDone = studentClickerList.every((item) => item.testedAllKeys);

        if (!allClickerKeyValidationDone) {
            this.setState({ errorMessage: 'Student Clicker Key Validation not Done' })
            return
        }

        let selectedSet = this.state.selectedSet

        selectedSet.allStudentClickerKeysTestDone = true
        selectedSet.teacherClickerKeysTestDone = true
        selectedSet.studentClickerList = studentClickerList

        this.props.delegate && this.props.delegate.addClickerIdToSet && this.props.delegate.addClickerIdToSet(selectedSet)
    }

    setClickerType(e, type) {
        this.setState({ clickerType: type })
    }

    stopScanning() {
         if (window.electron && window.electron.remoteControl) {
            window.electron.remoteControl.unsubscribeEvents();
            window.electron.remoteControl.close();
            this.setState({isListening : false})
            console.log('closing by done')
        }
    }

    render() {

        return (
            <div className="add-clicker-id">
                <div className="mb-2 d-flex align-items-center">
                    <img alt="" className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    <span className="screen-title">{this.state.schoolName}</span>
                </div>
                <div className=''>
                    <span className='screen-sub-title'>Add / Edit Clicker Id to {this.state.selectedSet?.setName}</span>
                </div>
                <button onClick={() => this.startRegister()}>Start Register</button>
                
                <div className="mt-2 table-title">Teacher Clicker ID</div>
                <div id="table-scoll" className="table-responsive">
                    <table className="table cw-table mb-0 align-items-center">
                        <thead>
                            <tr>
                                <th className="th-left-radius">Roll No</th>
                                <th>Device MAC ID</th>
                                <th>Battery (30)</th>
                                <th>Tested</th>
                                <th>A</th>
                                <th>B</th>
                                <th>C</th>
                                <th>D</th>
                                <th>E</th>
                                <th>F</th>
                                <th>G</th>
                                <th>H</th>
                                <th className="th-right-radius">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {this.state.selectedSet.teacherClickerId ? (
                                <tr key={this.state.selectedSet.teacherClickerId.rollNumber}>
                                    <td>{this.state.selectedSet.teacherClickerId.rollNumber}</td>
                                    <td>
                                        <input
                                            type="text"
                                            value={this.state.selectedSet.teacherClickerId.deviceMacId}
                                            onFocus={(e) => this.setClickerType(e, 'TEACHER_CLICKER')}
                                            onChange={(e) => this.handleMacIdChange(this.state.selectedSet.teacherClickerId.rollNumber, e)}
                                            ref={(input) => (this.inputRefs[this.state.selectedSet.teacherClickerId.rollNumber] = input)}
                                        />
                                    </td>
                                    <td>{this.state.selectedSet.teacherClickerId.voltage}</td>
                                    <td>{this.state.selectedSet.teacherClickerId.testedAllKeys ? "✅" : "❌"}</td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={this.state.selectedSet.teacherClickerId.a}
                                            onChange={() => this.handleCheckboxChange(this.state.selectedSet.teacherClickerId.rollNumber, "a")}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={this.state.selectedSet.teacherClickerId.b}
                                            onChange={() => this.handleCheckboxChange(this.state.selectedSet.teacherClickerId.rollNumber, "b")}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={this.state.selectedSet.teacherClickerId.c}
                                            onChange={() => this.handleCheckboxChange(this.state.selectedSet.teacherClickerId.rollNumber, "c")}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={this.state.selectedSet.teacherClickerId.d}
                                            onChange={() => this.handleCheckboxChange(this.state.selectedSet.teacherClickerId.rollNumber, "d")}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={this.state.selectedSet.teacherClickerId.e}
                                            onChange={() => this.handleCheckboxChange(this.state.selectedSet.teacherClickerId.rollNumber, "e")}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={this.state.selectedSet.teacherClickerId.f}
                                            onChange={() => this.handleCheckboxChange(this.state.selectedSet.teacherClickerId.rollNumber, "f")}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={this.state.selectedSet.teacherClickerId.g}
                                            onChange={() => this.handleCheckboxChange(this.state.selectedSet.teacherClickerId.rollNumber, "g")}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={this.state.selectedSet.teacherClickerId.h}
                                            onChange={() => this.handleCheckboxChange(this.state.selectedSet.teacherClickerId.rollNumber, "h")}
                                        />
                                    </td>
                                    <td>
                                        <button className={`done-button cursor-pointer`}
                                            style={{ backgroundColor: `${this.state.selectedSet.teacherClickerId.testedAllKeys ? '#008FFF' : '#6c757d'}` }}>Done</button>
                                        <button onClick={() => this.removeItem(this.state.selectedSet.teacherClickerId.rollNumber, 'TEACHER_CLICKER')}>Remove</button>
                                    </td>
                                </tr>
                            )
                                : <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Records found</td></tr>

                            }
                        </tbody>
                    </table>
                </div>

                <div className="mt-2 table-title">Student Clicker List -  <strong>Clicker Count {this.state.selectedSet?.clickerCount}</strong> </div>
                <div id="table-scoll" className="table-responsive">
                    <table className="table cw-table mb-0 align-items-center">
                        <thead>
                            <tr>
                                <th className="th-left-radius">Roll No</th>
                                <th>Device MAC ID</th>
                                <th>Battery (30)</th>
                                <th>Tested</th>
                                <th>A</th>
                                <th>B</th>
                                <th>C</th>
                                <th>D</th>
                                <th>E</th>
                                <th className="th-right-radius">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white">
                            {this.state.selectedSet?.studentClickerList.length ? this.state.selectedSet?.studentClickerList.map((item) => (
                                <tr key={item.rollNumber}>
                                    <td>{item.rollNumber}</td>
                                    <td>
                                        <input
                                            type="text"
                                            value={item.deviceMacId}
                                            onFocus={(e) => this.setClickerType(e, 'STUDENT_CLICKER')}
                                            onChange={(e) => this.handleMacIdChange(item.rollNumber, e)}
                                            ref={(input) => (this.inputRefs[item.rollNumber] = input)}
                                        />
                                    </td>
                                    <td>{item.voltage}</td>
                                    <td>{item.testedAllKeys ? "✅" : "❌"}</td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={item.a}
                                            onChange={() => this.handleCheckboxChange(item.rollNumber, "a")}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={item.b}
                                            onChange={() => this.handleCheckboxChange(item.rollNumber, "b")}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={item.c}
                                            onChange={() => this.handleCheckboxChange(item.rollNumber, "c")}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={item.d}
                                            onChange={() => this.handleCheckboxChange(item.rollNumber, "d")}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={item.e}
                                            onChange={() => this.handleCheckboxChange(item.rollNumber, "e")}
                                        />
                                    </td>
                                    <td>
                                        <button onClick={() => this.stopScanning()}>Done</button>
                                        <button onClick={() => this.removeItem(item.rollNumber)}>Remove</button>
                                    </td>
                                </tr>
                            ))
                                : <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Records found</td></tr>

                            }
                        </tbody>
                    </table>
                </div>
                <div>
                    {
                        this.state.selectedSet?.studentClickerList.length && this.state.selectedSet?.studentClickerList[0].deviceMacId ?
                            <div className="cursor-pointer d-flex align-items-center justify-content-center text-center save-button d-inline-block cw-button-primary" onClick={() => this.addClickerIdToSet()}>Save</div>
                            :
                            <div className="d-flex align-items-center justify-content-center text-center save-button d-inline-block disable-button" >Save</div>
                    }
                </div>
                {
                    this.state.errorMessage ? <div className="error-status mt-2">{this.state.errorMessage}</div> : <></>
                }
            </div>
        )
    }
}

export default AddClickerId;